    <h1>Database Development Managed in Git - Database DevOps</h1>
<br>

 <p>
    Database code should be managed in Git just like other code. It works by having an individual SQL script file for each database object and they are stored in directories named after their object type.
 </p>

 <div class="image-container">
    <img src="Tables.png" alt="Tables"  class="responsive"  />
</div>
<br>
<br>

<br>
 <p>
    The initial version of each script is usually the create script. A change script for a subsequent release will replace the contents of the file and be checked in as a new version of that file. The Git history of each file is then the history of changes to that database object. Ideally, each version will also be associated with a change ticket number to ensure full traceability.
</p>

<br>
<div class="image-container">
    <img src="History.png" alt="History" class="responsive" />
</div>
<br>
<br>

<br>
 <p>
    <b>GitToolset</b> is used to extract all of the files in Git changed since the last release, sort them, and combine them to build a single release script. The release script is then applied to a test copy of your database for testing. This can all be done from your CI/CD pipeline. 
</p>
<p>
    Any database changes needed during testing requires an updated script, a commit to Git, a newly generated release script file and a clean test database. No manual changes are allowed outside of the process.
</p>
<p>
    Once everything passes, the same fully tested script file is applied to each subsequent environment and tested until it is deployed to the production database.
</p>    
<p>
    This automated, auditable workflow empowers large teams to deploy with precision and confidence.
</p>
<br>



    <div class="quote">
        <blockquote>
            <p>
                As a result every database refactoring is automated by writing it in the form of SQL DDL (for the schema change) and DML (for the data migration). These changes are never applied manually...
                <br>...run the migration scripts on the mainline copy of the database, and then run all the application tests. If all is green, this process will be repeated across the whole Deployment Pipeline, including QA and Staging environments. The same code finally is run against production, now updating the live database's schema and data.
            </p>
                -- <a href="https://en.wikipedia.org/wiki/Martin_Fowler">Martin Fowler</a> and <a href="https://www.nofluffjuststuff.com/conference/speaker/pramod_sadalage">Pramod Sadalage</a>
                &nbsp;&nbsp;<cite title="Evolutionary Database Design"><a href="http://martinfowler.com/articles/evodb.html" alt="Book" target="_blank">Evolutionary Database Design</a></cite>
        </blockquote>
    
    </div>

    <br>
    <br>

    <h2>Next Steps</h2>
    <ul>
       <!-- <li><a href="#">Watch the video</a></li>-->
       <li>Review <a href="/documentation">Documentation</a></li>
        <li>Obtain a license from <a href="/product">Product</a></li>
        <li>Download and install Git Toolset from <a href="/downloads">Download Git Toolset</a></li>
    </ul>
<br><br><br>

